export default __webpack_public_path__ + "static/media/search_magnifiy.332405e8.svg";